import { combineReducers } from 'redux'
import * as constants from './constants'
import * as grsConstants from 'grs/constants'
import { LOGOUT } from 'auth/constants'

const rates = (state = [], { type, rates }) => (type === constants.SET_RATES ? rates : state)

const customerFlow = (state = null, { type, customerFlow }) => {
    switch (type) {
        case constants.SET_CURRENT_CUSTOMER_FLOW:
            return customerFlow
        default:
            return state
    }
}

const selectedRate = (state = null, action) => {
    switch (action.type) {
        case constants.SELECT_RATE:
            return action.selectedRateId
        case constants.CLEAR_SELECTED_RATE:
        case constants.EXIT_BOOKING_FLOW:
            return null
        default:
            return state
    }
}

const selectedVehicles = (state = [], { type, selectedVehicles, vehicle }) => {
    switch (type) {
        case constants.SET_SELECTED_VEHICLE:
            if (!selectedVehicles) {
                return []
            }

            if (Array.isArray(selectedVehicles)) {
                return selectedVehicles
            } else {
                return [selectedVehicles]
            }

        case constants.REMOVE_FROM_SELECTED_VEHICLES:
            return state.filter($vehicle => $vehicle.id !== vehicle.id)
        case LOGOUT:
            return []
        default:
            return state
    }
}

const card = (state = null, payload) => {
    switch (payload.type) {
        case constants.SET_SELECTED_CREDIT_CARD:
            return payload.card
        case LOGOUT:
            return null
        default:
            return state
    }
}

//TODO: refactor this into promoCode reducer
const rawPromoCode = (state = '', { type, value }) => {
    switch (type) {
        case constants.SET_RAW_PROMO_CODE:
            return value
        case constants.CLEAR_LAST_BOOKING_DETAILS:
        case constants.CLEAR_SELECTED_RATE:
        case constants.EXIT_BOOKING_FLOW:
        case grsConstants.GET_SEASON_TICKETS:
            return ''

        default:
            return state
    }
}

const autoRenew = (state = false, { type, autoRenew }) => {
    switch (type) {
        case constants.SET_AUTO_RENEW:
            return autoRenew
        default:
            return state
    }
}

const promoCode = (state = null, { type, promoCode }) => {
    switch (type) {
        case constants.REDEEMED_PROMO_CODE:
            return {
                ...promoCode,
            }
        case constants.REMOVE_PROMO_CODE:
        case constants.SET_PARKING_MODE:
        case constants.CLEAR_SELECTED_RATE:
        case grsConstants.GET_SEASON_TICKETS:
            return null
        default:
            return state
    }
}

const lastBookingDetails = (state = null, { type, grsId, rateId, subscriptions, waitingListKey, rate, id }) => {
    switch (type) {
        case constants.SET_LAST_BOOKING_DETAILS:
            return {
                ...state,
                grsId,
                rateId,
                subscriptions,
                waitingListKey,
                rate,
                id,
            }
        case constants.CLEAR_LAST_BOOKING_DETAILS:
        case constants.EXIT_BOOKING_FLOW:
        case constants.CLEAR_SELECTED_RATE:
            return null
        default:
            return state
    }
}

const bookingLocationDetails = (state = {}, { type, locationDetails }) => {
    switch (type) {
        case constants.SET_BOOKING_LOCATION_DETAILS:
            return locationDetails
        case constants.EXIT_BOOKING_FLOW:
            return {}
        default:
            return state
    }
}

export const CARDS = {
    SELECT_PARKING_TIME: 'SELECT_PARKING_TIME',
    AVAILABLE_PRODUCTS: 'AVAILABLE_PRODUCTS',
    CONFIRM_VEHICLE: 'CONFIRM_VEHICLE',
    PAY_FOR_PARKING: 'PAY_FOR_PARKING',
}

export const disabledCardsInitialState = {
    SELECT_PARKING_TIME: true,
    AVAILABLE_PRODUCTS: true,
    CONFIRM_VEHICLE: true,
    PAY_FOR_PARKING: true,
}

const disabledCards = (state = disabledCardsInitialState, { type, cards }) => {
    switch (type) {
        case constants.ENABLE_CARD:
            return cards.reduce((acc, key) => ({ ...acc, [key]: false }), state)
        case constants.CLEAR_SELECTED_RATE:
        case constants.EXIT_BOOKING_FLOW:
            return disabledCardsInitialState
        default:
            return state
    }
}

const seasonTickets = (state = [], { type, seasonTickets }) => {
    switch (type) {
        case grsConstants.RECEIVED_SEASON_TICKETS:
            return seasonTickets
        default:
            return state
    }
}

const selectedSeasonTicketDefaultState = { ticket: null, rate: null }

const selectedSeasonTicket = (state = selectedSeasonTicketDefaultState, { type, ticket, rate }) => {
    switch (type) {
        case constants.SELECT_SEASON_TICKET:
            return { ...state, ticket }
        case constants.RECEIVED_SELECTED_SEASON_TICKET_RATE:
        case constants.RECEIVED_WAITING_LIST_RATE:
            return { ...state, rate }
        case constants.CLEAR_SELECTED_RATE:
        case constants.EXIT_BOOKING_FLOW:
            return selectedSeasonTicketDefaultState
        default:
            return state
    }
}

const parkingMode = (state = null, { type, searchMode }) => (type === constants.SET_PARKING_MODE ? searchMode : state)

const waitingListKey = (state = null, { type, waitingListKey }) => {
    switch (type) {
        case grsConstants.VALIDATED_WAITING_LIST_KEY:
            return waitingListKey
        case constants.EXIT_BOOKING_FLOW:
        case constants.CLEAR_SELECTED_RATE:
            return null
        default:
            return state
    }
}

const waitingListNextAvailableDate = (state = null, { type, rate }) => {
    switch (type) {
        case constants.RECEIVED_WAITING_LIST_RATE:
            return rate.fromDate
        case constants.EXIT_BOOKING_FLOW:
        case constants.CLEAR_SELECTED_RATE:
            return null
        default:
            return state
    }
}

const upSellOptions = (state = null, { type, upsellOptions }) => {
    switch (type) {
        case constants.SET_UPSELL_OPTIONS:
            return upsellOptions
        case constants.FAILED_TO_FETCH_UPSELL_OPTIONS:
            return upsellOptions
        default:
            return state
    }
}

const additionalParkingItems = (state = null, { type, additionalItems }) => {
    switch (type) {
        case constants.SET_ADDITIONAL_PARKING_ITEMS:
            return additionalItems
        case constants.GET_ADDITIONAL_PARKING_ITEMS_ERROR:
            return additionalItems
        default:
            return state
    }
}

const selectedUpSellOption = (state = null, { type, selectedOption }) => {
    switch (type) {
        case constants.SELECT_UPSELL_RATE:
            return selectedOption
        case constants.CLEAR_SELECTED_UPSELL_RATE:
            return null
        default:
            return state
    }
}

const threeDs = (state = null, { type, challengeURL3DS, challengeData3DS }) => {
    switch (type) {
        case constants.VERIFY_3DS:
            return {
                ...state,
                challengeURL3DS,
                challengeData3DS,
            }
        case constants.DISCARD_3DS: {
            return null
        }
        default:
            return state
    }
}

const guestUserChekoutData = (state = null, { type, data, error }) => {
    switch (type) {
        case constants.SET_GUEST_USER_PERSONAL_DETAILS:
            return { ...state, guestUserPersonalData: data }
        case constants.VERIFY_GUEST_USER_SUCCESS:
            return {
                ...state,
                guestUserCardIsVerified: data,
            }
        case constants.VERIFY_GUEST_USER_FAILED:
            return {
                ...state,
                guestUserCardIsVerifiedFailed: error,
            }
        case constants.VERIFY_GUEST_USER_RESET:
            return { ...state, guestUserCardIsVerified: null, guestUserCardIsVerifiedFailed: null }
        default:
            return state
    }
}

const purchaseCompleted = (state = null, { type, paymentTotal, orderEmailAddress }) => {
    switch (type) {
        case constants.PURCHASE_COMPLETED:
            return { paymentTotal, orderEmailAddress }
        case constants.CLEAR_PURCHASE_COMPLETED:
            return null
        default:
            return state
    }
}

const appReducer = combineReducers({
    rates,
    selectedRate,
    card,
    lastBookingDetails,
    bookingLocationDetails,
    disabledCards,
    selectedVehicles,
    seasonTickets,
    selectedSeasonTicket,
    parkingMode,
    rawPromoCode,
    promoCode,
    autoRenew,
    waitingListKey,
    waitingListNextAvailableDate,
    upSellOptions,
    selectedUpSellOption,
    additionalParkingItems,
    threeDs,
    guestUserChekoutData,
    customerFlow,
    purchaseCompleted,
})

export const booking = (state, action) => {
    switch (action.type) {
        case constants.RESET_BOOKING_STATE:
        case LOGOUT:
            return appReducer(undefined, action)
        default:
            return appReducer(state, action)
    }
}
